import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Message } from "src/app/core/class/message";
import { AuthenticationService } from "src/app/core/services/authentication.service";
import { CommonService } from "src/app/core/services/common.service";
import { NotificationService } from "src/app/core/services/notification.service";
import { StorageService } from "src/app/core/services/storage.service";
import { UserService } from "src/app/core/services/user.service";
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { WarningComponent } from "../warning/warning.component";

@Component({
    selector: 'mysign-session-configuration',
    templateUrl: './mysign-session-configuration.component.html',
    styleUrls: ['./mysign-session-configuration.component.scss']
})
export class MysignSessionConfiguration extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {

    value: boolean = true
    isFormChanging = false;
    constructor(
        private userService: UserService,
        private el: ElementRef,
        public dialogRef: MatDialogRef<MysignSessionConfiguration>,
        private dialog: MatDialog,
        public notificationService: NotificationService,
        public commonService: CommonService,
        public message: Message,
        private toastr: ToastrService,
        private router: Router,
        private auth: AuthenticationService,
        private storage: StorageService
    ) {
    super(commonService, message);
    dialogRef.disableClose = true;
    
    }
    ngOnInit(){
        this.userService.getMysignSessionConfiguration().subscribe(res =>{
            console.log(res);
            if(res.success){
                this.value = res.data.receiveUserConfigTransactionMysign.value
            } else {
                this.toastr.error(res.message)
            }
        })
    }

    ngAfterViewInit(){

    }

    ngOnDestroy(){

    }

    cancel() {
        if (this.isFormChanging) {
            const dialogRe = this.dialog.open(WarningComponent, {
                width: '350px',
                data: 'messages.confirm_change_data'
            });
            dialogRe.afterClosed().subscribe(result => {
                if (result) {
                this.isFormChanging = false
                this.dialogRef.close();
                }
                dialogRe.close();
            });
        } else {
          this.dialogRef.close();
        }
    }

    saveConfig(){
        
        this.userService.saveMysignSessionConfiguration({value: this.value}).subscribe(res =>{
            if(res.success){
                this.toastr.success(this.message.getMessage('mysign-session-config.save_session_success'))
                this.dialogRef.close();
            } else {
                this.toastr.error(res.message)
            }
            
        })
    }
    changeForm(ev: any){
        this.isFormChanging = true
    }
}